﻿import {
	Drivers,
	getHiddenDriverProperties,
	getHiddenResidencyProperties,
	getHiddenVehicleProperties,
	PermitId,
	Permits,
	PermitStatusComponent,
	Residencies,
	ResidencyUses,
	Tariffs,
	Vehicles,
	Zones
} from "@2d-front-monorepo/permits-business";

import {JSX} from "react";
import {useParams} from "react-router";
import InvalidPermitId from "../../components/InvalidPermitId";
import {PermitsBackButtonFrame} from "../../components/PermitsBackButton";
import Registrations from "../../customers/Registrations";
import {useGlobalContext} from "../../hooks/useGlobalContext";
import {usePermits} from "../../hooks/usePermits";
import {PrivateRoutes} from "../../routes";
import {DriverWithChangeComponent} from "./ViewComponents/DriverWithChange";
import {FooterComponent} from "./ViewComponents/FooterComponent";
import {HolderComponent} from "./ViewComponents/HolderComponent";
import {ResidencyWithChangeComponent} from "./ViewComponents/ResidencyWithChange";
import {VehiclesComponent} from "./ViewComponents/VehiclesComponent";

export default function ViewPermit(): JSX.Element {
	const {permitId} = useParams<{ permitId: string }>() as { permitId: PermitId };
	const installation = useGlobalContext();
	const {permits, holderData} = usePermits();
	const permit = Permits.find(permits, permitId);

	if (permit == null) {
		return <InvalidPermitId permitId={permitId}/>;
	}

	const PermitComponent = Registrations.getPermitPage();

	const tariff = Tariffs.get(holderData, permit.tariffId);
	const zone = Zones.get(holderData, permit.parkingLocation.zoneId);

	const driver = Drivers.getChanged(permits, permit.driver);
	const residency = Residencies.getChanged(permits, permit.residency);
	const vehicles = Vehicles.getChanged(permits, permit.vehicles);

	const hiddenDriverProperties = getHiddenDriverProperties(installation.installation);
	const hiddenResidencyProperties = getHiddenResidencyProperties(installation.installation, residency?.original?.entity?.uses ?? ResidencyUses.None);
	const hiddenVehicleProperties = getHiddenVehicleProperties(installation.installation, vehicles[0].original.entity.type);

	return (
		<>
			<div className="layout horizontal aligned middle">
				<h2 className="flex">{tariff.title}</h2>
				<PermitStatusComponent permit={permit}/>
			</div>
			<hr className="no-margin-start"/>
			<div className="layout vertical gap">
				<HolderComponent permit={permit}
				                 permits={permits}
				                 zone={residency == null ? zone : undefined}/>

				{residency && <ResidencyWithChangeComponent holderData={holderData}
                                                            residency={residency.original}
                                                            hiddenEntityProperties={hiddenResidencyProperties}
                                                            changedResidency={residency.changed}/>}

				{driver && <DriverWithChangeComponent driver={driver.original}
                                                      hiddenEntityProperties={hiddenDriverProperties}
                                                      changedDriver={driver.changed}/>}

				<VehiclesComponent vehicles={vehicles}
				                   hiddenEntityProperties={hiddenVehicleProperties}/>

				<FooterComponent payment={permit.payment}/>
				<PermitComponent tariff={tariff}
				                 zone={zone}
				                 group={{
					                 permits: permits.permits,
					                 permit: permit,
					                 name: "",
					                 count: 1,
					                 startDate: permit.startDate,
					                 endDate: permit.endDate
				                 }}
				                 permits={permits}
				                 holderData={holderData}
				                 driver={driver}
				                 residency={residency}
				                 vehicles={vehicles}
				                 now={installation.now}/>
			</div>

			<PermitsBackButtonFrame href={PrivateRoutes.permitsList}/>
		</>
	)
}
